exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--ds-grid-gap:0.75rem;--ds-grid-gutter:1.5rem}@media (min-width:60rem){:root{--ds-grid-gap:1rem;--ds-grid-gutter:2rem}}", ""]);

// exports
